import React from 'react'
import { KeyboardControl, ControlHighlight } from '../../molecules/KeyboardControls'
import { HighlightEffect } from '../../../enums/KeyboardControls'
import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'

export type HexChoiceType = 'radio' | 'checkbox'

interface HexChoiceButtonProps {
  id: string
  label: string
  isSelected: boolean
  isRequired?: boolean
  isInvalid?: boolean
  type: HexChoiceType
  onClick: () => void
  layer?: string
}

const HexChoiceButton: React.FC<HexChoiceButtonProps> = ({
  id,
  label,
  isSelected,
  isRequired = false,
  isInvalid = false,
  type,
  onClick,
  layer = 'survey'
}) => {
  const keyboardControls = useKeyboardControls()

  const getRole = () => type === 'radio' ? 'radio' : 'checkbox'

  return (
    <ControlHighlight
      active={keyboardControls.isEnabled && keyboardControls.isElementFocused(id)}
      highlightEffect={HighlightEffect.InputOutline}
    >
      <KeyboardControl layer={layer}>
        <button
          id={id}
          role={getRole()}
          aria-checked={isSelected}
          aria-required={isRequired}
          aria-invalid={isInvalid}
          aria-label={label}
          onClick={onClick}
          className={`
            w-6 h-6 flex-shrink-0 cursor-pointer transition-all duration-200 flex items-center justify-center
            clip-hexagon
            ${isSelected
              ? 'bg-dopage-primary'
              : 'bg-dopage-tealGray'
            }
          `}
        >
          {isSelected && (
            <span className='text-black font-bold text-sm select-none pointer-events-none'>
              ✓
            </span>
          )}
        </button>
      </KeyboardControl>
    </ControlHighlight>
  )
}

export default HexChoiceButton
